/**
 * L2-S4: moved to @miq/platform (services/edp-records-update.service.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'.
 *
 * The service is still `@Injectable()` with NO `providedIn` — every consumer provides it in a
 * route's or component's `providers` array so each route gets its own instance. Import the CLASS
 * from here or from '@miq/platform'; both are the same class object, so an existing
 * `providers: [EdpRecordsUpdateService]` entry keeps working unchanged.
 */
export { EdpRecordsUpdateService } from '@miq/platform';
